import { vPicklist } from '../validation/index.ts'
import type { LocationAccessorialDTO } from './location-accessorial.ts'

export const shipTypes = [
  'airport',
  'business dock',
  'business no dock',
  'construction',
  'farm',
  'grocery',
  'limited access',
  'military',
  'mine',
  'prison',
  'pier',
  'place of worship',
  'residential',
  'school',
  'trade show',
] as const

export type ShipType = (typeof shipTypes)[number]

export const vShipType = () => vPicklist(shipTypes)

export const shipTypeLabels: Record<ShipType, string> = {
  airport: 'Airport',
  'business dock': 'Business w/ dock or forklift',
  'business no dock': 'Business w/out dock or forklift',
  construction: 'Construction site',
  farm: 'Farm',
  grocery: 'Grocery warehouse',
  'limited access': 'Limited access',
  military: 'Government/Military',
  mine: 'Mine',
  pier: 'Pier/Port',
  'place of worship': 'Place of worship',
  prison: 'Prison',
  residential: 'Residential',
  school: 'School',
  'trade show': 'Tradeshow',
}

export const ShipTypeMapper = {
  display(st?: ShipType, showBusinessType = true): string | undefined {
    if (!st) return undefined
    if (!showBusinessType && /business/.test(st)) {
      return ''
    }
    return shipTypeLabels[st]
  },

  displayLocShipType({
    shipType,
    accessorials,
  }: {
    shipType?: ShipType | ''
    accessorials?: LocationAccessorialDTO[]
  }) {
    if (
      !shipType ||
      shipType === 'business dock' ||
      shipType === 'business no dock'
    ) {
      return undefined
    }

    const shipName = shipTypeLabels[shipType]

    if (shipType === 'trade show') {
      const booth = accessorials?.find(
        a => a.key === 'tradeshow',
      )?.tradeshowBooth
      if (booth) {
        return `${shipName} (Booth ${booth})`
      }
    }

    return shipName
  },
}
